import * as React from "react";
import type { SVGProps } from "react";
const SvgHighFloorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M19.28 2v5.76h-5.76v5.76H7.76v5.76H2V26h.96v-5.76h5.76v-5.76h5.76V8.72h5.76V2.96H26V2zm1.725 11.04a.484.484 0 0 0 .105.96h2.775l-10.71 10.695a.487.487 0 1 0 .69.69l10.695-10.71v2.775a.48.48 0 0 0 .238.422c.15.086.334.086.484 0 .15-.088.24-.25.238-.422v-4.41h-4.41a.3.3 0 0 0-.06 0z"
    />
  </svg>
);
export default SvgHighFloorIcon;
